import { useCallback } from 'react'
import { useAtomValue } from 'jotai'
import { UserService } from '@duck/api-definitions'
import { userAtom } from '@/store/userAtoms'

export type Badge = UserService.UserBadge

export const useUserBadges = () => {
  const user = useAtomValue(userAtom)
  const badges: Badge[] = user?.badges ?? []

  const hasBadge = useCallback(
    (badge: Badge): boolean => badges.includes(badge),
    [badges]
  )

  return { hasBadge, badges }
}
